<div class="meal-plan-container">
  <span class="meal-plan">
    <mb-icon-text *ngIf="bedsInput?.beds">
      <mb-icon icon="sleep"></mb-icon>
      <span>{{ bedsInput.beds }}</span>
    </mb-icon-text>
    <mb-icon-text
      *ngIf="rateInput.meal_plan"
      [ngSwitch]="rateInput.meal_plan.code"
      style="margin: 0; padding: 5px"
    >
      <mb-icon *ngSwitchCase="'ROOM_ONLY'" icon="sleep"></mb-icon>
      <mb-icon *ngSwitchCase="'BREAKFAST'" icon="breakfast"></mb-icon>
      <mb-icon *ngSwitchCase="'HALF_BOARD_MORE_DRINKS'" icon="mealplan"></mb-icon>
      <mb-icon *ngSwitchCase="'FULL_BOARD'" icon="full-board"></mb-icon>
      <mb-icon *ngSwitchCase="'ALL_INCLUSIVE'" icon="all-inclusive"></mb-icon>
      <span>{{ rateInput.meal_plan.description | uppercase }}</span>
    </mb-icon-text>
  </span>
  <cancel-policies-information
    [ngClass]="isMobile ? 'mb-col-12' : ''"
    [policies]="rateInput.cancel_policies"
    [refundable]="rateInput.refundable"
  ></cancel-policies-information>
</div>
